import { formEncode, getToken, handleResponse, nextJsonApi } from '@/API/core';

const dashboard = {
  getData: async (data: any) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextJsonApi.post('/dashboard', formEncode(data), {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  getMonthlyARCollected: async (data: any) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextJsonApi.post(
        '/dashboard/monthly-ar-collected',
        formEncode(data),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  getReturnReport: async (data: any) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextJsonApi.post(
        '/dashboard/return-report',
        formEncode(data),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  getLogs: async (data: any) => {
    let response = null;
    try {
      response = await nextJsonApi.post('/logs/winston', formEncode(data));
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  getAllCompaniesData: async (data: any) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextJsonApi.post('/dashboard/all-companies', formEncode(data), {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  getPaymentPostedCollections: async (data: any) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextJsonApi.post('/dashboard/payment-posted-collections', formEncode(data), {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
  getPaymentByMonthComparison: async (data: any) => {
    let response = null;
    const token = await getToken();
    try {
      response = await nextJsonApi.post(
        '/dashboard/payment-by-month-comparison',
        formEncode(data),
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
    } catch (e) {
      response = e;
    }
    return handleResponse(response);
  },
};

export default dashboard;
